<!--
  One field, not two (October 2026): the country code is a compact "+91" button inside the mobile field's left
  edge, opening a menu, so the number keeps nearly the whole width of a normal field wherever it is placed.
  As two side-by-side fields in one grid cell, the number was left too narrow to show a whole mobile number.
-->
<mat-form-field appearance="outline" class="phone-input">
  <mat-label>
    {{ label }}
    @if (required) {
      <span class="required-asterisk">*</span>
    }
  </mat-label>
  <button
    type="button"
    class="phone-code"
    [attr.aria-label]="'COMMON.COUNTRY_CODE' | translate"
    [matMenuTriggerFor]="codeMenu"
    [disabled]="numberControl.disabled"
    [matTooltip]="selectedCountry()?.name ?? ''"
    matPrefix
  >
    +{{ countryCodeControl.value }}<mat-icon class="phone-code-arrow">arrow_drop_down</mat-icon>
  </button>
  @if (autocomplete) {
    <input type="tel" [formControl]="numberControl" [matAutocomplete]="autocomplete" matInput maxlength="20" autocomplete="off" />
  } @else {
    <input type="tel" [formControl]="numberControl" matInput maxlength="20" autocomplete="tel-national" />
  }
  <!-- The errors live here, not as content from the parent form (October 2026): mat-form-field only puts a
       mat-error under the field when it is declared in the same template, so a projected one rendered inside it. -->
  @if (numberControl.hasError('required')) {
    <mat-error>{{ 'COMMON.REQUIRED' | translate }}</mat-error>
  } @else if (numberControl.hasError('invalidMobile')) {
    <mat-error>{{ 'COMMON.INVALID_MOBILE' | translate }}</mat-error>
  }
</mat-form-field>

<mat-menu #codeMenu="matMenu" class="phone-code-menu">
  @for (country of countries(); track country.id) {
    <button type="button" (click)="countryCodeControl.setValue(dialCode(country))" mat-menu-item>
      <span aria-hidden="true">{{ flagEmoji(country.code) }}</span>
      +{{ dialCode(country) }} {{ country.name }}
    </button>
  }
</mat-menu>
